/**
 * IconTextGrid - grid of icon + text feature blocks.
 * Custom element: <icon-text-grid>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class IconTextGrid extends ThemeComponent {}
setFunctionName(IconTextGrid, "IconTextGrid");
const propertyTypes = {};
IconTextGrid.prototype.$name = "IconTextGrid";
IconTextGrid.prototype.$info = JSON.parse('{"name":"IconTextGrid","meta":{"isLegacy":false,"selector":"icon-text-grid"},"props":[],"refs":[]}');
IconTextGrid.prototype.$info.component = IconTextGrid;
for (const prop of IconTextGrid.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("IconTextGrid/IconTextGrid.ts", {
  IconTextGrid: IconTextGrid
}, void 0);